/**
 * Get the backend API URL from runtime config or environment variable
 * This allows the URL to be configured at runtime for production deployments
 */
export const getApiUrl = () => {
  // First check if runtime config is available (loaded from public/config.js)
  if (window.ENV && window.ENV.REACT_APP_BACKEND_URL) {
    return window.ENV.REACT_APP_BACKEND_URL;
  }

  // Fall back to build-time environment variable
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }

  // Default to localhost for development
  return 'http://localhost:3001';
};
